interface Setting {
    width?: number;
    height?: number;
}

const addUrlParameter = (url: string, key: string, value: string | number) => {
    const separator = url.indexOf('?') > -1 ? '&' : '?';

    return `${url}${separator}${key}=${value}`;
};

const createImageUrl = (image: string, { width, height }: Setting) => {
    let url = addUrlParameter(image, 'mode', 'crop');

    if (width) url = addUrlParameter(url, 'width', width);
    if (height) url = addUrlParameter(url, 'height', height);

    return url;
};

export default createImageUrl;
